import { SET_PROVIDER, SET_WALLET_ADDRESS } from '../types/actionTypes';

// export const setValue = (value) => ({
//   type: SET_VALUE,
//   payload: value,
// });

export const setWalletAddress = (walletAddress) => ({
    type: SET_WALLET_ADDRESS,
    payload: walletAddress,
  });
  
  export const setProvider = (provider) => ({
    type: SET_PROVIDER,
    payload: provider,
  });